import { Mesh, BoxGeometry, MeshLambertMaterial, CylinderGeometry, Geometry } from "three";
import { environment } from '@/environment';

export default class Brick {
    private mesh: Mesh;

    constructor(unitWidth: number, unitLength: number, color: string) {
        const cubeGeo = new BoxGeometry(
            environment.gridUnitWidth * unitWidth,
            environment.gridUnitHeight, 
            environment.gridUnitLength * unitLength
        );
        const cylinderGeo = new CylinderGeometry(
            environment.gridUnitWidth / 5,
            environment.gridUnitWidth / 5,
            environment.gridUnitHeight / 3,
            10
        );
        const material = new MeshLambertMaterial({color: color});

        const cube = new Mesh(cubeGeo);
        cube.updateMatrix();
        const finalGeo = new Geometry();
        finalGeo.merge(cube.geometry as Geometry, cube.matrix);

        for (let x = 0; x < unitWidth; x++ ) {
            for (let y = 0; y < unitLength; y++ ) {
                const cylinder = new Mesh(cylinderGeo);
                cylinder.translateY(environment.gridUnitHeight / 2);
                cylinder.updateMatrix();
                finalGeo.merge(cylinder.geometry as Geometry, cylinder.matrix);
            }
        }
        
        this.mesh = new Mesh(finalGeo, material);
        this.mesh.castShadow = true;
        this.mesh.receiveShadow = true;
    }

    public getMesh(): Mesh {
        return this.mesh;
    }
}
